/*******************************************************************************
TRIGGER TIME PERIOD CHANGE
Triggers the time period to change.
*******************************************************************************/
import changeTimePeriod from './change-time-period';

export default function triggerTimePeriodChange(e) {

    const $selectedOption = $(e.currentTarget);
    const urlToActivate = $selectedOption.find(':selected').data('url');

    changeTimePeriod(urlToActivate);
}
